@if (info()) {
  <ul class="contact-info flex-auto text-left">
    <!-- @if (info().companyName) {
      <li>
        <i class="material-icons text-{{ color() }}">business</i>
        <p class="m-0 ml-2">
          {{ info().companyName | translate }}
        </p>
      </li>
    } -->
    <!-- @if (info().registrationNumber) {
      <li>
        <i class="material-icons text-{{ color() }}">assignment</i>
        <p class="m-0 ml-2">統編 {{ info().registrationNumber }}</p>
      </li>
    } -->
    @if (info().fullAddress) {
      <li>
        <i class="material-icons text-{{ color() }}">location_on</i>
        <p class="m-0 ml-2">
          {{ info().fullAddress | translate }}
        </p>
      </li>
    }
    @if (info().brokerLicenseNumber) {
      <li>
        <i class="material-icons text-{{ color() }}">person</i>
        <p class="m-0 ml-2">
          <!-- 不動產經紀人證號： -->
          {{ info().brokerLicenseNumber }}
        </p>
      </li>
    }
    <!-- @if (businessEntity()) {
      <li>
        <i class="material-icons text-{{ color() }}">person</i>
        <p class="m-0 ml-2">
          {{ businessEntity() | translate }}
        </p>
      </li>
    } -->
    @if (info().email) {
      <li>
        <i class="material-icons text-{{ color() }}">email</i>
        <p class="m-0 ml-2 min-w-0 break-all">
          {{ info().email }}
        </p>
      </li>
    }
    @if (info().phoneNumber) {
      <li>
        <i class="material-icons text-{{ color() }}">phone</i>
        <p class="m-0 ml-2">{{ info().phoneNumber }}</p>
      </li>
    }
    @if (info().homeNumber) {
      <li>
        <i class="material-icons text-{{ color() }}">home</i>
        <p class="m-0 ml-2">{{ info().homeNumber }}</p>
      </li>
    }
    @if (info().fax) {
      <li>
        <i class="material-icons text-{{ color() }}">fax</i>
        <p class="m-0 ml-2">{{ info().fax }}</p>
      </li>
    }
  </ul>
}
